import { render, staticRenderFns } from "./setpConfig.vue?vue&type=template&id=aba319e2&scoped=true"
import script from "./setpConfig.vue?vue&type=script&lang=js"
export * from "./setpConfig.vue?vue&type=script&lang=js"
import style0 from "./setpConfig.vue?vue&type=style&index=0&id=aba319e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba319e2",
  null
  
)

export default component.exports